import React, { Component } from "react"

import logo from "../../images/articLogo.jpg"

import "./Hero.scss";

class Hero extends Component {
  render() {
    return (
      <section id="hero">
        <img className="logo" src={logo} alt="articBakehouse logo"/>
      </section>
    )
  }
}

export default Hero